import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import t from '../../../../../../lib/translate';
var SendWindowList = function (_a) {
    var windows = _a.windows;
    if (windows.length === 0) {
        return _jsx(_Fragment, { children: t('templates.table.send.windows.continuously') });
    }
    var wholeWeek = 7;
    windows.sort(function (a, b) { return b.days.length - a.days.length; });
    return (_jsx(_Fragment, { children: windows.map(function (window) {
            var days = window.days.split(',');
            return (_jsxs("span", { children: [window.start, " - ", window.end, days.length < wholeWeek &&
                        _jsxs(_Fragment, { children: [" [", days.map(function (day) { return t("templates.table.send.windows.".concat(day)); }).join(', '), "]", _jsx("br", {})] })] }, JSON.stringify(window)));
        }) }));
};
export default SendWindowList;
